import React from 'react';
import TextField from '@mui/material/TextField';

export default ({
  label,
  input,
  meta = {},
  info,
  forceError,
  InputLabelProps,
  placeholder,
  ...rest
}) => {
  // isTouched: true if user interacted or form submitted
  const isTouched = Boolean(
    meta.touched || meta.isTouched || meta.isSubmitted || meta.submitFailed
  );
  const rawError = meta.error;
  const hasError = Boolean(rawError);
  // eslint-disable-next-line no-underscore-dangle
  const errorMessage = typeof rawError === 'object' ? (rawError?.message || rawError?._error) : rawError;
  const showError = hasError && (isTouched || forceError);
  const helperText = showError && errorMessage ? errorMessage : info;

  const val = input?.value ?? rest.value;
  const safeValue = (val === null || val === undefined) ? '' : val;
  const hasValue = safeValue !== '';

  return (
    <TextField
      label={label}
      placeholder={placeholder === undefined ? label : placeholder}
      error={showError}
      helperText={helperText}
      InputLabelProps={{
        ...(hasValue ? { shrink: true } : {}),
        ...InputLabelProps,
        ...rest.InputLabelProps
      }}
      {...input}
      {...rest}
      value={safeValue}
    />
  );
};
